
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgxPaginationModule } from "ngx-pagination";
import { NgxEditorModule } from 'ngx-editor';
import{ NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ng2-tooltip-directive';
import { CKEditorModule } from 'ng2-ckeditor';
import { NgxSpinnerModule } from "ngx-spinner";
import { PreviousUrlGuard } from '../previousurl.guard';
import { StationComponent } from './station/station.component';
import { ProductionPlannerService } from './productionplanner.service';
import { ProductionUserAttendanceComponent } from './productionuserattendance/productionuserattendance.component';
import { WorkFlowComponent } from './workflow/workflow.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

const appRoutes: Routes = [   
   { path: 'production-planner/station', component: StationComponent,canActivate:[PreviousUrlGuard]},
   { path: 'production-planner/team-attendance', component: ProductionUserAttendanceComponent,canActivate:[PreviousUrlGuard]},
   { path: 'production-planner/work-flow', component: WorkFlowComponent,canActivate:[PreviousUrlGuard]}
  ];
  
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes,{enableTracing:true}),
        //RouterModule.forChild(appRoutes),
        FormsModule,
        CommonModule,
        BsDatepickerModule.forRoot(),
        NgMultiSelectDropDownModule,
        NgxEditorModule,
        PopoverModule,
        Ng2SearchPipeModule,
        TooltipModule,
        CKEditorModule ,
        NgxSpinnerModule,
        NgxPaginationModule,
		DragDropModule,
        PerfectScrollbarModule
      ],
      exports: [RouterModule],
      declarations: [
        StationComponent,
        ProductionUserAttendanceComponent,
		WorkFlowComponent
      ],
      providers:[ProductionPlannerService]
 
  })
  export class ProductionPlannerModule { }